interface GuarantorInfoProps {
    guarantorName?: string;
}

export const GuarantorInfo: React.FC<GuarantorInfoProps> = ({ guarantorName }) => {
    return (
        <>
            <div className='lending-limits-guarantorSummaryInfo-section'>
                <div>Guarantor:</div>
                <div className='lending-limits-guarantorSummaryInfo-section-name'>
                    <b>{guarantorName}</b>
                </div>
            </div>
        </>
    );
};
